'use client'
import { useEffect } from 'react'

import LAYOUT_TYPES from '@src/quince-site-common/src/constants/layoutTypes'
import { PRODUCT_FEED_TYPE } from '@src/quince-site-common/src/services/productFeedService/productFeedService.types'
import ProductListTwo from '@src/SectionRenderer/sections/productListTwo'
import { ProductListTwoSectionConfig } from '@src/SectionRenderer/sections/productListTwo/ProductListTwo'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

import styles from './search.module.scss'
import SearchResultsSection from './searchResultsSection/SearchResultsSection'

const productListTwoProps: ProductListTwoSectionConfig = {
  typename: 'CustomSection',
  id: 'searchPageaBestSellers',
  classNames: ['background-color--offWhite'],
  influencers: [],
  layoutType: LAYOUT_TYPES.DEFAULT,
  baseDynamicClasses: [],
  mobileDynamicClassesOverrides: [],
  classNamesMobileOverrides: [],
  productFeedType: PRODUCT_FEED_TYPE.CUSTOMER_TOP_PRODUCTS,
  productFeedLimit: 4,
  productFeedMetaData: undefined,
  heading: 'Best Sellers',
  headingClassname: styles.bestsellerHeading,
}

export default function SearchPage() {
  useEffect(() => {
    trackEvent(TELEMETRY_EVENT_NAMES.SEARCH_PAGE_VIEW, {})
  }, [])

  return (
    <>
      <SearchResultsSection />
      <ProductListTwo sectionConfig={productListTwoProps} />
    </>
  )
}
